import { render, staticRenderFns } from "./CargoCrudStatusSearchVehicle.vue?vue&type=template&id=09541785"
import script from "./CargoCrudStatusSearchVehicle.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusSearchVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports